import { EmoticonHappyOutlineIcon } from './EmoticonHappyOutlineIcon';

/**
 * author: Gabriel
 * id F51C2659-3EE9-471C-A919-190D3C1A9681
 * name emoticon-happy-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-happy-outline.svg
 * tags
 * - Emoji 
 */
export const EmojiHappyOutlineIcon = EmoticonHappyOutlineIcon;
export default EmojiHappyOutlineIcon